import http from './Http';

function list(onSuccess, onError) {
  http.get('/mcp-token/list', {}, onSuccess, onError);
}

function create(data, onSuccess, onError) {
  http.post('/mcp-token/create', data, onSuccess, onError);
}

function remove(id, onSuccess, onError) {
  http.delete('/mcp-token/delete', { id }, onSuccess, null, onError);
}

export default {
  list,
  create,
  remove,
};
